// Generated by purs version 0.14.4
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Void from "../Data.Void/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Internal from "../Foreign.Generic.Internal/index.js";
import * as Foreign_Index from "../Foreign.Index/index.js";
import * as Foreign_NullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record from "../Record/index.js";
import * as Record_Builder from "../Record.Builder/index.js";
import * as Type_Data_RowList from "../Type.Data.RowList/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var TaggedObject = (function () {
    function TaggedObject(value0) {
        this.value0 = value0;
    };
    TaggedObject.create = function (value0) {
        return new TaggedObject(value0);
    };
    return TaggedObject;
})();
var RecArg = (function () {
    function RecArg(value0) {
        this.value0 = value0;
    };
    RecArg.create = function (value0) {
        return new RecArg(value0);
    };
    return RecArg;
})();
var PlainArg = (function () {
    function PlainArg(value0) {
        this.value0 = value0;
    };
    PlainArg.create = function (value0) {
        return new PlainArg(value0);
    };
    return PlainArg;
})();
var voidEncode = {
    encode: Data_Void.absurd
};
var voidDecode = {
    decode: function (v) {
        return Control_Monad_Except_Trans.except(Data_Identity.applicativeIdentity)(new Data_Either.Left(Control_Applicative.pure(Data_List_Types.applicativeNonEmptyList)(new Foreign.ForeignError("Decode: void"))));
    }
};
var unitEncode = {
    encode: function (v) {
        return Foreign.unsafeToForeign([  ]);
    }
};
var unitDecode = {
    decode: function (v) {
        return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_Unit.unit);
    }
};
var unArg = function (v) {
    if (v instanceof RecArg) {
        return v.value0;
    };
    if (v instanceof PlainArg) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Foreign.Generic.Class (line 281, column 1 - line 281, column 24): " + [ v.constructor.name ]);
};
var stringEncode = {
    encode: Foreign.unsafeToForeign
};
var stringDecode = {
    decode: Foreign.readString(Data_Identity.monadIdentity)
};
var numberEncode = {
    encode: Foreign.unsafeToForeign
};
var numberDecode = {
    decode: Foreign.readNumber(Data_Identity.monadIdentity)
};
var intEncode = {
    encode: Foreign.unsafeToForeign
};
var intDecode = {
    decode: Foreign.readInt(Data_Identity.monadIdentity)
};
var genericEncodeArgsNoArguments = {
    encodeArgs: function (v) {
        return Data_Monoid.mempty(Data_Monoid.monoidFn(Data_List_Types.monoidList));
    }
};
var genericDecodeNoConstructors = {
    decodeOpts: function (opts) {
        return function (v) {
            return Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("No constructors"));
        };
    }
};
var genericDecodeArgsNoArguments = {
    decodeArgs: function (v) {
        return function (v1) {
            return function (v2) {
                if (v2 instanceof Data_List_Types.Nil) {
                    return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))({
                        result: Data_Generic_Rep.NoArguments.value,
                        rest: Data_List_Types.Nil.value,
                        next: v1
                    });
                };
                return Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("Too many constructor arguments"));
            };
        };
    },
    decodeSingleRecordArg: Data_Maybe.Nothing.value
};
var genericCountArgsNoArguments = {
    countArgs: function (v) {
        return new Data_Either.Left(Data_Generic_Rep.NoArguments.value);
    }
};
var genericCountArgsArgument = {
    countArgs: function (v) {
        return new Data_Either.Right(1);
    }
};
var foreignEncode = {
    encode: Control_Category.identity(Control_Category.categoryFn)
};
var foreignDecode = {
    decode: Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))
};
var encodeWithOptions = function (dict) {
    return dict.encodeWithOptions;
};
var genericEncodeArgsArgument = function (dictEncodeWithOptions) {
    return {
        encodeArgs: function (opts) {
            return function (v) {
                return Data_List.singleton(new PlainArg(encodeWithOptions(dictEncodeWithOptions)(opts)(v)));
            };
        }
    };
};
var genericEncodeArgsRecord = function (dictEncodeWithOptions) {
    return {
        encodeArgs: function (opts) {
            return function (v) {
                return Data_List.singleton(new RecArg(encodeWithOptions(dictEncodeWithOptions)(opts)(v)));
            };
        }
    };
};
var encodeRecordWithOptions = function (dict) {
    return dict.encodeRecordWithOptions;
};
var encodeWithOptionsRecord = function (dictRowToList) {
    return function (dictEncodeRecord) {
        return {
            encodeWithOptions: function (opts) {
                var $187 = encodeRecordWithOptions(dictEncodeRecord)(Type_Data_RowList.RLProxy.value)(opts);
                return function ($188) {
                    return Foreign.unsafeToForeign($187($188));
                };
            }
        };
    };
};
var encodeRecordNil = {
    encodeRecordWithOptions: function (v) {
        return function (v1) {
            return function (v2) {
                return Foreign_Object.empty;
            };
        };
    }
};
var encodeRecordCons = function (dictCons) {
    return function (dictEncodeRecord) {
        return function (dictIsSymbol) {
            return function (dictEncodeWithOptions) {
                return {
                    encodeRecordWithOptions: function (v) {
                        return function (opts) {
                            return function (rec) {
                                var obj = encodeRecordWithOptions(dictEncodeRecord)(Type_Data_RowList.RLProxy.value)(opts)(rec);
                                var l = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                                return Foreign_Object.insert(opts.fieldTransform(l))(encodeWithOptions(dictEncodeWithOptions)(opts)(Record.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(rec)))(obj);
                            };
                        };
                    }
                };
            };
        };
    };
};
var encodeOpts = function (dict) {
    return dict.encodeOpts;
};
var genericEncodeNoConstructors = {
    encodeOpts: function (opts) {
        return function (a) {
            return encodeOpts(genericEncodeNoConstructors)(opts)(a);
        };
    }
};
var genericEncodeSum = function (dictGenericEncode) {
    return function (dictGenericEncode1) {
        return {
            encodeOpts: function (opts) {
                return function (v) {
                    if (v instanceof Data_Generic_Rep.Inl) {
                        return encodeOpts(dictGenericEncode)({
                            sumEncoding: opts.sumEncoding,
                            unwrapSingleConstructors: false,
                            unwrapSingleArguments: opts.unwrapSingleArguments,
                            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                            fieldTransform: opts.fieldTransform
                        })(v.value0);
                    };
                    if (v instanceof Data_Generic_Rep.Inr) {
                        return encodeOpts(dictGenericEncode1)({
                            sumEncoding: opts.sumEncoding,
                            unwrapSingleConstructors: false,
                            unwrapSingleArguments: opts.unwrapSingleArguments,
                            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                            fieldTransform: opts.fieldTransform
                        })(v.value0);
                    };
                    throw new Error("Failed pattern match at Foreign.Generic.Class (line 398, column 1 - line 402, column 85): " + [ opts.constructor.name, v.constructor.name ]);
                };
            }
        };
    };
};
var encodeArgs = function (dict) {
    return dict.encodeArgs;
};
var genericEncodeArgsProduct = function (dictGenericEncodeArgs) {
    return function (dictGenericEncodeArgs1) {
        return {
            encodeArgs: function (opts) {
                return function (v) {
                    return Data_Semigroup.append(Data_List_Types.semigroupList)(encodeArgs(dictGenericEncodeArgs)(opts)(v.value0))(encodeArgs(dictGenericEncodeArgs1)(opts)(v.value1));
                };
            }
        };
    };
};
var encode = function (dict) {
    return dict.encode;
};
var encodeWithOptionsOther = function (dictEncode) {
    return {
        encodeWithOptions: function (v) {
            return encode(dictEncode);
        }
    };
};
var identityEncode = function (dictEncode) {
    return {
        encode: (function () {
            var $189 = encode(dictEncode);
            var $190 = Data_Newtype.unwrap();
            return function ($191) {
                return $189($190($191));
            };
        })()
    };
};
var maybeEncode = function (dictEncode) {
    return {
        encode: Data_Maybe.maybe(Foreign_NullOrUndefined["null"])(encode(dictEncode))
    };
};
var objectEncode = function (dictEncode) {
    return {
        encode: (function () {
            var $192 = Foreign_Object.mapWithKey(function (v) {
                return encode(dictEncode);
            });
            return function ($193) {
                return Foreign.unsafeToForeign($192($193));
            };
        })()
    };
};
var defaultOptions = {
    sumEncoding: new TaggedObject({
        tagFieldName: "tag",
        contentsFieldName: "contents",
        constructorTagTransform: Control_Category.identity(Control_Category.categoryFn)
    }),
    unwrapSingleConstructors: false,
    unwrapSingleArguments: true,
    unwrapSingleRecordArguments: false,
    fieldTransform: Control_Category.identity(Control_Category.categoryFn)
};
var recordEncode = function (dictRowToList) {
    return function (dictEncodeRecord) {
        return {
            encode: encodeWithOptions(encodeWithOptionsRecord()(dictEncodeRecord))(defaultOptions)
        };
    };
};
var decodeWithOptions = function (dict) {
    return dict.decodeWithOptions;
};
var decodeSingleRecordArg = function (dict) {
    return dict.decodeSingleRecordArg;
};
var decodeRecordWithOptions = function (dict) {
    return dict.decodeRecordWithOptions;
};
var decodeWithOptionsRecord = function (dictRowToList) {
    return function (dictDecodeRecord) {
        return {
            decodeWithOptions: function (opts) {
                return Data_Functor.map(Data_Functor.functorFn)(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Function.flip(Record_Builder.build)({})))(decodeRecordWithOptions(dictDecodeRecord)(Type_Data_RowList.RLProxy.value)(opts));
            }
        };
    };
};
var recordDecode = function (dictRowToList) {
    return function (dictDecodeRecord) {
        return {
            decode: decodeWithOptions(decodeWithOptionsRecord()(dictDecodeRecord))(defaultOptions)
        };
    };
};
var decodeRecordNil = {
    decodeRecordWithOptions: function (v) {
        return function (v1) {
            return function (v2) {
                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Control_Category.identity(Record_Builder.categoryBuilder));
            };
        };
    }
};
var decodeRecordCons = function (dictCons) {
    return function (dictDecodeRecord) {
        return function (dictIsSymbol) {
            return function (dictDecodeWithOptions) {
                return function (dictLacks) {
                    return {
                        decodeRecordWithOptions: function (v) {
                            return function (opts) {
                                return function (f) {
                                    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(decodeRecordWithOptions(dictDecodeRecord)(Type_Data_RowList.RLProxy.value)(opts)(f))(function (builder) {
                                        var l = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                                        var l_transformed = opts.fieldTransform(l);
                                        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.index(Foreign_Index.indexString(Data_Identity.monadIdentity))(f)(l_transformed))(function (f_) {
                                            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Monad_Except.mapExcept(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Functor.map(Data_List_Types.functorNonEmptyList)(Foreign.ErrorAtProperty.create(l_transformed))))(decodeWithOptions(dictDecodeWithOptions)(opts)(f_)))(function (a) {
                                                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder)(builder)(Record_Builder.insert()()(dictIsSymbol)(Data_Symbol.SProxy.value)(a)));
                                            });
                                        });
                                    });
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var decodeOpts = function (dict) {
    return dict.decodeOpts;
};
var genericDecodeSum = function (dictGenericDecode) {
    return function (dictGenericDecode1) {
        return {
            decodeOpts: function (opts) {
                return function (f) {
                    var opts$prime = {
                        unwrapSingleConstructors: false,
                        fieldTransform: opts.fieldTransform,
                        sumEncoding: opts.sumEncoding,
                        unwrapSingleArguments: opts.unwrapSingleArguments,
                        unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments
                    };
                    return Control_Alt.alt(Control_Monad_Except_Trans.altExceptT(Data_List_Types.semigroupNonEmptyList)(Data_Identity.monadIdentity))(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Generic_Rep.Inl.create)(decodeOpts(dictGenericDecode)(opts$prime)(f)))(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Generic_Rep.Inr.create)(decodeOpts(dictGenericDecode1)(opts$prime)(f)));
                };
            }
        };
    };
};
var decodeArgsArgument = function (dictDecodeWithOptions) {
    return function (v) {
        return function (v1) {
            return function (v2) {
                if (v2 instanceof Data_List_Types.Cons) {
                    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Monad_Except.mapExcept(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Functor.map(Data_List_Types.functorNonEmptyList)(Foreign.ErrorAtIndex.create(v1))))(decodeWithOptions(dictDecodeWithOptions)(v)(v2.value0)))(function (a) {
                        return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))({
                            result: a,
                            rest: v2.value1,
                            next: v1 + 1 | 0
                        });
                    });
                };
                return Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("Not enough constructor arguments"));
            };
        };
    };
};
var genericDecodeArgsArgument = function (dictDecodeWithOptions) {
    return {
        decodeArgs: decodeArgsArgument(dictDecodeWithOptions),
        decodeSingleRecordArg: Data_Maybe.Nothing.value
    };
};
var genericDecodeArgsRecord = function (dictDecodeWithOptions) {
    return {
        decodeArgs: decodeArgsArgument(dictDecodeWithOptions),
        decodeSingleRecordArg: new Data_Maybe.Just(function (options) {
            return function (i) {
                return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Generic_Rep.Argument)(decodeWithOptions(dictDecodeWithOptions)(options)(i));
            };
        })
    };
};
var decodeArgs = function (dict) {
    return dict.decodeArgs;
};
var genericDecodeArgsProduct = function (dictGenericDecodeArgs) {
    return function (dictGenericDecodeArgs1) {
        return {
            decodeArgs: function (opts) {
                return function (i) {
                    return function (xs) {
                        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(decodeArgs(dictGenericDecodeArgs)(opts)(i)(xs))(function (v) {
                            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(decodeArgs(dictGenericDecodeArgs1)(opts)(v.next)(v.rest))(function (v1) {
                                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))({
                                    result: new Data_Generic_Rep.Product(v.result, v1.result),
                                    rest: v1.rest,
                                    next: v1.next
                                });
                            });
                        });
                    };
                };
            },
            decodeSingleRecordArg: Data_Maybe.Nothing.value
        };
    };
};
var decode = function (dict) {
    return dict.decode;
};
var decodeWithOptionsOther = function (dictDecode) {
    return {
        decodeWithOptions: function (v) {
            return decode(dictDecode);
        }
    };
};
var identityDecode = function (dictDecode) {
    return {
        decode: (function () {
            var $194 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Identity.Identity);
            var $195 = decode(dictDecode);
            return function ($196) {
                return $194($195($196));
            };
        })()
    };
};
var maybeDecode = function (dictDecode) {
    return {
        decode: Foreign_NullOrUndefined.readNullOrUndefined(decode(dictDecode))
    };
};
var objectDecode = function (dictDecode) {
    return {
        decode: Control_Bind.composeKleisliFlipped(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))((function () {
            var $197 = Data_Traversable.sequence(Foreign_Object.traversableObject)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
            var $198 = Foreign_Object.mapWithKey(function (v) {
                return decode(dictDecode);
            });
            return function ($199) {
                return $197($198($199));
            };
        })())(Foreign_Generic_Internal.readObject)
    };
};
var genericEncodeConstructor = function (dictIsSymbol) {
    return function (dictGenericEncodeArgs) {
        return {
            encodeOpts: function (opts) {
                return function (v) {
                    var unwrapArguments = function (encoding) {
                        return function (v1) {
                            if (v1.length === 0) {
                                return encoding.noArgs;
                            };
                            var v2 = function (v3) {
                                if (v1.length === 1 && opts.unwrapSingleArguments) {
                                    return encoding["default"](unArg(v1[0]));
                                };
                                return encoding["default"](Foreign.unsafeToForeign(Data_Functor.map(Data_Functor.functorArray)(unArg)(v1)));
                            };
                            if (v1.length === 1 && v1[0] instanceof RecArg) {
                                var $147 = Control_Monad_Except.runExcept(decode(objectDecode(foreignDecode))(v1[0].value0));
                                if ($147 instanceof Data_Either.Right) {
                                    return encoding.singleRecord($147.value0);
                                };
                                return v2(true);
                            };
                            return v2(true);
                        };
                    };
                    var encodeArgsArray = function (encoding) {
                        var $200 = unwrapArguments(encoding);
                        var $201 = Data_List.toUnfoldable(Data_Unfoldable.unfoldableArray);
                        var $202 = encodeArgs(dictGenericEncodeArgs)(opts);
                        return function ($203) {
                            return $200($201($202($203)));
                        };
                    };
                    var ctorName = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                    if (opts.unwrapSingleConstructors) {
                        return encodeArgsArray({
                            noArgs: Foreign.unsafeToForeign({}),
                            singleRecord: Foreign.unsafeToForeign,
                            "default": Control_Category.identity(Control_Category.categoryFn)
                        })(v);
                    };
                    var encodedTag = Foreign_Object.singleton(opts.sumEncoding.value0.tagFieldName)(Foreign.unsafeToForeign(opts.sumEncoding.value0.constructorTagTransform(ctorName)));
                    var encodedArgs = encodeArgsArray({
                        noArgs: Foreign_Object.empty,
                        singleRecord: function (r) {
                            if (opts.unwrapSingleRecordArguments) {
                                return r;
                            };
                            return Foreign_Object.singleton(opts.sumEncoding.value0.contentsFieldName)(Foreign.unsafeToForeign(r));
                        },
                        "default": Foreign_Object.singleton(opts.sumEncoding.value0.contentsFieldName)
                    })(v);
                    return Foreign.unsafeToForeign(Foreign_Object.union(encodedTag)(encodedArgs));
                };
            }
        };
    };
};
var countArgs = function (dict) {
    return dict.countArgs;
};
var genericCountArgsProduct = function (dictGenericCountArgs) {
    return function (dictGenericCountArgs1) {
        return {
            countArgs: function (v) {
                var v1 = countArgs(dictGenericCountArgs1)(Type_Proxy["Proxy"].value);
                var v2 = countArgs(dictGenericCountArgs)(Type_Proxy["Proxy"].value);
                if (v2 instanceof Data_Either.Left && v1 instanceof Data_Either.Left) {
                    return new Data_Either.Left(new Data_Generic_Rep.Product(v2.value0, v1.value0));
                };
                if (v2 instanceof Data_Either.Left && v1 instanceof Data_Either.Right) {
                    return new Data_Either.Right(v1.value0);
                };
                if (v2 instanceof Data_Either.Right && v1 instanceof Data_Either.Left) {
                    return new Data_Either.Right(v2.value0);
                };
                if (v2 instanceof Data_Either.Right && v1 instanceof Data_Either.Right) {
                    return new Data_Either.Right(v2.value0 + v1.value0 | 0);
                };
                throw new Error("Failed pattern match at Foreign.Generic.Class (line 466, column 5 - line 470, column 40): " + [ v2.constructor.name, v1.constructor.name ]);
            }
        };
    };
};
var genericDecodeConstructor = function (dictIsSymbol) {
    return function (dictGenericDecodeArgs) {
        return function (dictGenericCountArgs) {
            return {
                decodeOpts: function (opts) {
                    return function (f) {
                        var numArgs = countArgs(dictGenericCountArgs)(Type_Proxy["Proxy"].value);
                        var readArguments = function (args) {
                            if (numArgs instanceof Data_Either.Left) {
                                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(numArgs.value0);
                            };
                            if (numArgs instanceof Data_Either.Right && (numArgs.value0 === 1 && opts.unwrapSingleArguments)) {
                                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(decodeArgs(dictGenericDecodeArgs)(opts)(0)(Data_List.singleton(args)))(function (v) {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Applicative.unless(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_List["null"](v.rest))(Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("Expected a single argument"))))(function () {
                                        return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(v.result);
                                    });
                                });
                            };
                            if (numArgs instanceof Data_Either.Right) {
                                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign.readArray(Data_Identity.monadIdentity)(args))(function (vals) {
                                    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(decodeArgs(dictGenericDecodeArgs)(opts)(0)(Data_List.fromFoldable(Data_Foldable.foldableArray)(vals)))(function (v) {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Applicative.unless(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_List["null"](v.rest))(Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("Expected " + (Data_Show.show(Data_Show.showInt)(numArgs.value0) + " constructor arguments")))))(function () {
                                            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(v.result);
                                        });
                                    });
                                });
                            };
                            throw new Error("Failed pattern match at Foreign.Generic.Class (line 325, column 9 - line 337, column 24): " + [ numArgs.constructor.name ]);
                        };
                        var ctorName = Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value);
                        if (opts.unwrapSingleConstructors) {
                            return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Generic_Rep.Constructor)(readArguments(f));
                        };
                        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Monad_Except.mapExcept(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Functor.map(Data_List_Types.functorNonEmptyList)(Foreign.ErrorAtProperty.create(opts.sumEncoding.value0.tagFieldName))))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.index(Foreign_Index.indexString(Data_Identity.monadIdentity))(f)(opts.sumEncoding.value0.tagFieldName))(Foreign.readString(Data_Identity.monadIdentity)))(function (tag) {
                            var expected = opts.sumEncoding.value0.constructorTagTransform(ctorName);
                            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Applicative.unless(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(tag === expected)(Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("Expected " + (Data_Show.show(Data_Show.showString)(expected) + " tag")))))(function () {
                                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(tag);
                            });
                        })))(function (tag) {
                            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))((function () {
                                var v = decodeSingleRecordArg(dictGenericDecodeArgs);
                                if (v instanceof Data_Maybe.Just && opts.unwrapSingleRecordArguments) {
                                    return v.value0(opts)(f);
                                };
                                return Control_Monad_Except.mapExcept(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Functor.map(Data_List_Types.functorNonEmptyList)(Foreign.ErrorAtProperty.create(opts.sumEncoding.value0.contentsFieldName))))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.index(Foreign_Index.indexString(Data_Identity.monadIdentity))(f)(opts.sumEncoding.value0.contentsFieldName))(readArguments));
                            })())(function (args) {
                                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(args);
                            });
                        });
                    };
                }
            };
        };
    };
};
var charEncode = {
    encode: Foreign.unsafeToForeign
};
var charDecode = {
    decode: Foreign.readChar(Data_Identity.monadIdentity)
};
var booleanEncode = {
    encode: Foreign.unsafeToForeign
};
var booleanDecode = {
    decode: Foreign.readBoolean(Data_Identity.monadIdentity)
};
var arrayEncode = function (dictEncode) {
    return {
        encode: (function () {
            var $204 = Data_Functor.map(Data_Functor.functorArray)(encode(dictEncode));
            return function ($205) {
                return Foreign.unsafeToForeign($204($205));
            };
        })()
    };
};
var arrayDecode = function (dictDecode) {
    return {
        decode: (function () {
            var readElement = function (i) {
                return function (value) {
                    return Control_Monad_Except.mapExcept(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Functor.map(Data_List_Types.functorNonEmptyList)(Foreign.ErrorAtIndex.create(i))))(decode(dictDecode)(value));
                };
            };
            var readElements = function (arr) {
                return Data_Traversable.sequence(Data_Traversable.traversableArray)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_Array.zipWith(readElement)(Data_Array.range(0)(Data_Array.length(arr)))(arr));
            };
            return Control_Bind.composeKleisli(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign.readArray(Data_Identity.monadIdentity))(readElements);
        })()
    };
};
export {
    countArgs,
    decode,
    decodeArgs,
    decodeOpts,
    decodeRecordWithOptions,
    decodeSingleRecordArg,
    decodeWithOptions,
    encode,
    encodeArgs,
    encodeOpts,
    encodeRecordWithOptions,
    encodeWithOptions,
    TaggedObject,
    defaultOptions,
    RecArg,
    PlainArg,
    unArg,
    decodeArgsArgument,
    voidDecode,
    unitDecode,
    foreignDecode,
    stringDecode,
    charDecode,
    booleanDecode,
    numberDecode,
    intDecode,
    identityDecode,
    arrayDecode,
    maybeDecode,
    objectDecode,
    recordDecode,
    voidEncode,
    unitEncode,
    foreignEncode,
    stringEncode,
    charEncode,
    booleanEncode,
    numberEncode,
    intEncode,
    identityEncode,
    arrayEncode,
    maybeEncode,
    objectEncode,
    recordEncode,
    decodeWithOptionsRecord,
    decodeWithOptionsOther,
    encodeWithOptionsRecord,
    encodeWithOptionsOther,
    decodeRecordNil,
    encodeRecordNil,
    decodeRecordCons,
    encodeRecordCons,
    genericDecodeNoConstructors,
    genericEncodeNoConstructors,
    genericDecodeConstructor,
    genericEncodeConstructor,
    genericDecodeSum,
    genericEncodeSum,
    genericDecodeArgsNoArguments,
    genericEncodeArgsNoArguments,
    genericDecodeArgsRecord,
    genericDecodeArgsArgument,
    genericEncodeArgsRecord,
    genericEncodeArgsArgument,
    genericDecodeArgsProduct,
    genericEncodeArgsProduct,
    genericCountArgsNoArguments,
    genericCountArgsArgument,
    genericCountArgsProduct
};
//# sourceMappingURL=index.js.map
